export enum OrderAttributeEnum {
	TAKE_PROFIT = 'Take Profit',
	STOP_LOSS = 'Stop Loss',
}
